import { isGdprCountry } from '@change-corgi/config/countries';

import type { FormValues, NormalizedFormValues } from 'src/app/pages/petitionDetails/shared/types';

export function normalizePublic(
	values: Pick<FormValues, 'countryCode' | 'public' | 'notPublic'>,
): NormalizedFormValues['public'] {
	return isGdprCountry(values.countryCode) ? !values.notPublic : !!values.public;
}
